// Handles the redirect from Emergent Auth: /auth/callback#session_id=...
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const session_id = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!session_id) {
        toast.error("Missing Google session id");
        nav("/login", { replace: true });
        return;
      }
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        await refresh();
        // Clean the URL fragment
        window.history.replaceState({}, "", "/auth/callback");
        toast.success(`Welcome${data.full_name ? `, ${data.full_name.split(" ")[0]}` : ""}!`);
        if (data.role === "admin") {
          nav("/admin", { replace: true });
        } else if (!data.has_health_profile) {
          nav("/health-profile", { replace: true });
        } else {
          nav("/dashboard", { replace: true });
        }
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen grid place-items-center bg-bone" data-testid="auth-callback-page">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-moss mx-auto" />
        <p className="mt-4 text-muted2">Signing you in…</p>
      </div>
    </div>
  );
}
